import FormatMenuBar from "./FormatMenuBar"
import ActionMenuBar from "./ActionMenuBar"

export default function WebEditorMenuBar() {
    return (
        <div className="tw-flex sm:tw-flex-col tw-gap-2 xl:tw-flex-row tw-flex-wrap tw-w-full tw-divide-x tw-divide-gray-300 tw-space-x-0 xl:tw-space-x-4 xl:tw-divide-x">
            <FormatMenuBar />
            <ActionMenuBar/>
        </div>
    )
}